import styled from "@emotion/styled";
import { Dropdown, Colors, Fonts } from "@snapchat/snap-design-system";
import { css } from "@emotion/css";

export const defaultButtonStyle = css`
    margin: 16px 0;

    .icon-down {
        color: ${Colors.WHITE};
    }

    &.sds-base-button.ant-btn.primary {
        height: 40px;
    }
`;

export const menuItemStyle = css`
    ${Fonts.Control.Input}
    color: ${Colors.Black.V50};
`;

export const SourceTypesDropdown = styled(Dropdown)`
    &.sds-base-button.ant-btn.primary {
        cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

        ${({ isDisabled }) => (isDisabled ? `background: ${Colors.Gray.V200};` : null)}
        ${({ isDisabled }) => (isDisabled ? `color: ${Colors.Gray.V300};` : null)}
        :hover {
            ${({ isDisabled }) => (isDisabled ? `box-shadow: none;` : null)}
        }
    }
`;
